import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { desktop_medium_sm, mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar } from '../../../global/commonStyle';

interface Props {
  isDark?: string;
  isLastData?: boolean;
}

const OuterDiv = styled.div`
  max-width: 1022px;
  padding-inline: var(--space-24);
  height: 100dvh;
  margin: auto;
  ${mobile_xl(css`
    padding-inline: var(--space-20);
    overflow: auto;
    ${HideScrollbar}
  `)}
`;

const Group = styled.div`
  box-orient: vertical;
  flex-direction: column;
  display: flex;
  ${mobile_xl(css`
    gap: var(--space-24);
  `)}
`;

const HeaderBlock = styled.div`
  position: sticky;
  top: 0;
  ${FlexBetween}
  background-color: var(--background-secondary);
  padding-block: var(--space-14);
  z-index: var(--z-index-999);
`;

const Heading = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  padding-block: var(--space-3);
`;
const RightHeading = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  .active {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
  }
  svg {
    cursor: pointer;
  }
  ${mobile_xl(css`
    gap: var(--space-6);
  `)}
`;
const Icon = styled.div`
  ${FlexCenter}
  .more-icon {
    cursor: pointer;
    fill: var(--text-secondary);
    stroke: var(--text-secondary);
    &:hover {
      background-color: var(--neutral-secondary);
      border-radius: var(--border-radius-4);
    }
  }
  ${mobile_xl(css`
    padding: var(--space-20);
  `)}
`;

const Title = styled.h1`
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  margin: var(--space-0);
  white-space: nowrap;
`;
const Icons = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--space-20);
  align-items: flex-start;
  ${desktop_medium_sm(css`
    flex-direction: column;
    padding-left: var(--space-0);
    overflow: auto;
    scrollbar-width: none;
    height: calc(100dvh - 54px);
  `)}
  ${mobile_xl(css`
    flex-direction: column;
    overflow: unset;
    width: calc(100vw - 40px);
    gap: var(--space-24);
    padding-top: var(--space-8);
  `)}
`;
const LeftContentWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 728px;
  height: calc(100dvh - 54px);
  ${HideScrollbar}
  ${desktop_medium_sm(css`
    max-width: 100%;
    height: unset;
    overflow: unset;
  `)}
  ${mobile_xl(css`
    margin-left: var(--space-0);
    justify-content: center;
  `)}
`;

const MainDiv = styled.div<Props>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 100%;
  border-inline: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  max-width: 678px;
  ${desktop_medium_sm(css`
    max-width: calc(100% - 50px);
  `)}
  ${mobile_xl(css`
    gap: var(--space-24);
    width: calc(100vw - 68px);
    padding-inline: var(--space-8);
  `)}
`;

const TopInvoice = styled.div`
  display: flex;
  justify-content: space-between;
  padding-inline: var(--space-20);
  .invoice-logo-image {
    max-width: 40px;
    max-height: 24px;
    height: auto;
    border-radius: var(--border-radius-4);
    ${mobile_xl(css`
      max-height: 40px;
    `)}
  }
  ${mobile_xl(css`
    flex-direction: column-reverse;
    gap: var(--space-24);
    padding: var(--space-0);
  `)}
`;

const InvoiceLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-32);
  margin-top: var(--space-24);
  ${mobile_xl(css`
    width: 100%;
    margin-top: var(--space-0);
  `)}
`;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
`;
const InputId = styled.div`
  display: flex;
  gap: var(--space-14);
  justify-content: space-between;
  p {
    ${Typography.body_md_medium}
    color: var(--text-primary);
    margin: var(--space-0);
    width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  h1 {
    ${Typography.body_md}
    color: var(--text-secondary);
    margin: var(--space-0);
    align-items: flex-end;
    max-width: 70px;
    width: 100%;
  }
  ${mobile_xl(css`
    justify-content: unset;
  `)}
`;
const Text = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  align-items: flex-end;
  white-space: break-spaces;
  ${mobile_xl(css`
    width: 100%;
  `)}
`;
const TextDate = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  align-items: flex-end;
`;
const Info = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  width: 100%;
`;
const Info1 = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;
const Infotext = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  width: 206px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${desktop_medium_sm(css`
    width: unset;
  `)}
  ${mobile_xl(css`
    width: 206px;
  `)}
`;
const InvoiceMiddle = styled.div`
  margin-top: -23px;
  display: flex;
  img {
    clip-path: inset(24% 0 0 0);
  }
  ${mobile_xl(css`
    margin-top: var(--space-0);
    position: absolute;
    top: 5px;
    right: 5px;
  `)}
`;
const InvoiceRight = styled.div`
  margin-top: var(--space-24);
  display: flex;
  flex-direction: column;
  gap: var(--space-32);
  width: 273px;
  ${mobile_xl(css`
    max-width: 100%;
    width: 100%;
    gap: var(--space-18);
    margin: var(--space-0);
  `)}
`;
const InvoiceTitle = styled.div`
  text-align: center;
  ${Typography.heading_lg}
  color: var(--text-secondary);
`;
const Address = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  ${mobile_xl(css`
    gap: var(--space-24);
  `)}
`;
const From = styled.div`
  display: flex;
  justify-content: end;
  gap: var(--space-20);
  ${mobile_xl(css`
    gap: var(--space-4);
    justify-content: unset;
    width: 100%;
    flex-direction: column;
  `)}
`;
const FromAddress = styled.div`
  display: flex;
  flex-direction: column;
  width: 178px;
  ${mobile_xl(css`
    width: 100%;
  `)}
`;

const InvoiceTable = styled.div``;
const ActivityContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  padding-top: var(--space-6);
`;
const GroupHeader = styled.div`
  padding: var(--space-11) var(--space-20);
  justify-content: space-between;
  display: flex;
  border-top: 0.5px solid var(--border-primary);
  background: var(--background-tertiary);
  margin-top: var(--space-32);
`;
const RightHeader = styled.div`
  ${AlignCenter}
`;
const Label = styled.label`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;
const Quantity = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  border-right: 0.5px solid var(--border-primary);
  padding-right: var(--space-12);
  margin: var(--space-0);
  text-transform: uppercase;
`;
const Amount = styled.p`
  width: 100px;
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  padding-left: var(--space-12);
  margin: var(--space-0);
  text-align: end;
  text-transform: uppercase;
`;
const Price = styled.p`
  width: 88px;
  text-align: end;
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  border-right: 0.5px solid var(--border-primary);
  padding-inline: var(--space-11) var(--space-12);
  margin: var(--space-0);
  text-transform: uppercase;
`;
const Row = styled.div`
  padding: var(--space-8) var(--space-20);
  ${FlexBetween}
  margin: var(--space-0);
  gap: var(--space-12);
  border-top: 0.5px solid var(--border-primary);
  ${mobile_xl(css`
    width: 100%;
    flex-direction: column;
    padding: var(--space-0);
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-4);
    gap: var(--space-0);
  `)}
`;
const LeftRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: var(--space-0);
  max-width: 362px;
  width: 100%;
  ${mobile_xl(css`
    background-color: var(--background-secondary);
    max-width: none;
    padding: var(--space-10);
    border-bottom: 0.5px solid var(--border-primary);
    width: calc(100% - 20px);
    border-radius: var(--border-radius-4) var(--border-radius-4) var(--border-radius-0) var(--border-radius-0);
  `)}
`;

const RightRow = styled.div`
  display: flex;
  margin: var(--space-0);
  ${mobile_xl(css`
    flex-direction: column;
    width: 100%;
  `)}
`;

const TableDataResponsive = styled.div<Props>`
  ${mobile_xl(css<Props>`
    border-bottom: 0.5px solid var(--border-primary);
    padding: var(--space-8) var(--space-10);
    ${FlexBetween}
    gap: var(--space-10);
    ${(props) =>
      props.isLastData &&
      css`
        border-bottom: none;
      `}
  `)}
`;

const InvoiceTableTitle = styled.h5`
  display: none;
  ${mobile_xl(css`
    display: block;
    color: var(--text-secondary);
    margin: var(--space-0);
    text-transform: uppercase;
  `)}
`;

const InfoRate = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  text-align: end;
  width: 88px;
  padding-inline: var(--space-12);
  ${mobile_xl(css`
    padding: var(--space-0);
    text-align: unset;
    width: auto;
  `)}
`;

const Total = styled.div<{ isHideBottomBorder: boolean }>`
  padding: var(--space-20);
  border-top: 0.5px solid var(--border-primary);
  border-bottom: 0.5px solid var(--border-primary);
  gap: var(--space-12);
  display: flex;
  flex-direction: column;
  ${(props: { isHideBottomBorder: boolean }) =>
    props.isHideBottomBorder &&
    css`
      border-bottom: none;
    `}
  ${mobile_xl(css`
    border-top: none;
    padding: var(--space-24) var(--space-8) var(--space-32);
    margin: var(--space-0) -8px;
    gap: var(--space-10);
  `)}
`;

const TopContentTotal = styled.div`
  display: flex;
  gap: var(--space-12);
  flex-direction: column;
  ${mobile_xl(css`
    gap: var(--space-4);
  `)}
`;
const Subtotal = styled.div`
  ${AlignCenter}
  justify-content: end;
  gap: var(--space-24);
  ${mobile_xl(css`
    justify-content: space-between;
  `)}
`;

const Name = styled.div`
  ${Typography.body_md}
  color: var(--text-secondary);
`;

const TotalAmount = styled.div`
  ${AlignCenter}
  justify-content: end;
  gap: var(--space-24);
  ${mobile_xl(css`
    justify-content: space-between;
    padding-top: var(--space-12);
    border-top: 0.5px solid var(--border-primary);
  `)}
`;
const TotalContent = styled.p`
  ${Typography.heading_md}
  align-items: center;
  margin: var(--space-0);
  width: 100px;
  text-align: end;
  color: var(--text-primary);
`;
const TotalContents = styled.p`
  ${Typography.heading_md}
  align-items: center;
  margin: var(--space-0);
  color: var(--text-primary);
`;
const TotalRate = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  width: 100px;
  text-align: end;
`;
const NoteDiv = styled.div`
  padding: var(--space-20);
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
  p {
    ${Typography.body_md}
    color: var(--text-primary);
    margin: var(--space-0);
    white-space: break-spaces;
  }
  h2 {
    ${Typography.heading_sm}
    align-items: center;
    color: var(--text-primary);
    margin: var(--space-0);
  }
  ${mobile_xl(css`
    padding-block: var(--space-14);
    gap: var(--space-6);
  `)}
`;
const Activity = styled.div`
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  padding: var(--space-16);
  margin-bottom: var(--space-24);
  ${mobile_xl(css`
    margin-bottom: var(--space-96);
  `)}
`;
const ActivityBottom = styled.div`
  max-width: 274px;
  width: 100%;
  height: calc(100dvh - 54px);
  ${HideScrollbar}
  ${desktop_medium_sm(css`
    max-width: unset;
    max-width: unset;
    width: 100%;
    overflow: unset;
    height: unset;
  `)}
  ${mobile_xl(css`
    max-width: calc(100vw - 40px);
  `)}
`;
const ActivityRow = styled.li`
  border-top: 0.5px solid var(--border-primary);
  padding-top: var(--space-8);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
`;
const ActivityLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  ${mobile_xl(css`
    width: 100%;
  `)}
`;
const ActivityRight = styled.div`
  text-align: center;
  .active {
    display: inline-flex;
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
  }
`;
const RecordDropdown = styled.div`
  padding: var(--space-16) var(--space-20);
  border-radius: var(--border-radius-8);
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  ${mobile_xl(css`
    padding-bottom: var(--space-12);
  `)}
`;
const RecordDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

const QuantityRate = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  width: 28px;
  text-align: center;
  padding-inline: var(--space-12);
  ${mobile_xl(css`
    padding: var(--space-0);
    width: auto;
  `)}
`;

const AmountRate = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  width: 100px;
  text-align: end;
  padding-left: var(--space-12);
  ${mobile_xl(css`
    padding: var(--space-0);
    width: auto;
  `)}
`;

const InvoiceResponsive = styled.div`
  ${mobile_xl(css`
    ${FlexCenter}
    flex-direction: column;
    gap: var(--space-12);
    padding-block: var(--space-18);
  `)}
`;

const InvoiceCard = styled.div`
  ${mobile_xl(css`
    display: flex;
    flex-direction: column;
    gap: var(--space-12);
    justify-content: center;
  `)}
`;
const HeaderLeft = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
`;

const LeftContent = styled.div`
  width: 100%;
  display: flex;
  height: max-content;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  overflow: hidden;
  margin-bottom: var(--space-24);
  ${desktop_medium_sm(css`
    margin-bottom: unset;
  `)}
  ${mobile_xl(css`
    border-radius: var(--border-radius-4);
  `)}
`;

const DottedDesign = styled.div<Props>`
  background: var(--background-tertiary);
  width: 24px;
  ${({ isDark }) =>
    isDark === 'light'
      ? css`
          background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M7 12.3422C10.3137 12.3422 13 9.69115 13 6.42087C13 3.1506 10.3137 0.499512 7 0.499512C3.68629 0.499512 1 3.1506 1 6.42087C1 9.69115 3.68629 12.3422 7 12.3422Z' fill='%23F6F9FC' stroke='%23E3E8EA' strokeWidth='0.888889'/%3E%3C/svg%3E");
        `
      : css`
          background-image: url("data:image/svg+xml,%3Csvg width='8' height='8' viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M7 12.3422C10.3137 12.3422 13 9.69115 13 6.42087C13 3.1506 10.3137 0.499512 7 0.499512C3.68629 0.499512 1 3.1506 1 6.42087C1 9.69115 3.68629 12.3422 7 12.3422Z' fill='%232E2E30' stroke='%232E2E30' strokeWidth='0.888889'/%3E%3C/svg%3E");
        `}
  background-repeat: repeat-y;
  background-position: center;
  background-size: 18px;
  ${mobile_xl(css`
    width: 16px;
    background-size: 8px;
  `)}
`;

export {
  OuterDiv,
  Group,
  HeaderBlock,
  Heading,
  Icon,
  Title,
  RightHeading,
  Icons,
  Content,
  LeftContent,
  MainDiv,
  Activity,
  InvoiceTable,
  TopInvoice,
  InvoiceRight,
  InvoiceMiddle,
  InvoiceLeft,
  Details,
  InputId,
  Text,
  Info,
  Infotext,
  FromAddress,
  From,
  Address,
  InvoiceTitle,
  ActivityContent,
  GroupHeader,
  Quantity,
  Amount,
  Label,
  Price,
  RightHeader,
  Row,
  RightRow,
  LeftRow,
  InfoRate,
  Total,
  Subtotal,
  Name,
  TotalAmount,
  TotalContent,
  TotalRate,
  NoteDiv,
  ActivityRow,
  ActivityLeft,
  ActivityRight,
  RecordDropdown,
  RecordDetail,
  AmountRate,
  QuantityRate,
  ActivityBottom,
  Info1,
  TotalContents,
  TextDate,
  InvoiceResponsive,
  InvoiceCard,
  TopContentTotal,
  TableDataResponsive,
  InvoiceTableTitle,
  HeaderLeft,
  LeftContentWrapper,
  DottedDesign
};
